//* 组件库
import type { UiModal } from "various-ui";
//* 全局组件
import type { SearchGeneModal } from "@/components/windows";

export const useComposable = () => {
    //* 响应式变量
    const refs = {
        keyword: ref<string>(""),
    };

    //* 节点
    const nodes = {
        info: ref<InstanceType<typeof UiModal>>(),
        modal: ref<InstanceType<typeof SearchGeneModal>>(),
    };

    //* 函数列表
    const methods = {
        //* 页面跳转
        open: (result: any) => routerPush({ name: "BioSequenceResult", params: { id: result.id }, query: { mode: "cDNA" } }),
        //* 页面跳转
        next: () => open("https://www.bilibili.com/video/BV1yVGXzqEQ5", "_blank"),
    };

    return { refs, nodes, methods };
};
